
<records-image-content-block svgSrc="../../assets/man.svg" imgAlign="right">
  <p class="banner__description">{{ description }}</p>
  <h1 class="banner__title">{{ title }}</h1>
  <div class="banner__text">
    <ng-content select=".banner__text"></ng-content>
  </div>
  <ng-content select=".button__primary"></ng-content>
  <ng-content select=".button.icon-arrow"></ng-content>
</records-image-content-block>